<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>
        {{$route.meta.title}}
      </h3>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>用户管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel :collapse="false">
      <template slot="header">搜索</template>
      <el-form :model="search"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">
        <div class="re-el-form__flex">
          <el-form-item label="用户ID"
                        prop="id">
            <el-input placeholder="请输入用户ID"
                      v-model="search.userid"
                      clearable></el-input>
          </el-form-item>

          <el-form-item label="关键字"
                        prop="keyword">
            <el-input placeholder="请输入名称"
                      v-model="search.keyword"
                      clearable></el-input>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>
          <el-button icon="sj-icon-export"
                     @click="onExportSearch()">导出
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <div class="margin b15">
        <el-button type="primary"
                   icon="sj-icon-add"
                   @click="addUserDialog.visible = true"
                   size="small">添加用户
        </el-button>
        <el-upload style="display: inline-block"
                   ref="upload"
                   action=""
                   :auto-upload="false"
                   :on-change="query => onUploadFile(query, 255)"
                   accept=".xlsx,.xls"
                   :show-file-list="false">
          <el-tooltip content="上传表格的第一列请勿出现空值，出现空值将直接结束批量任务">
            <el-button icon="sj-icon-export"
                       type="primary"
                       size="small">批量添加用户
            </el-button>
          </el-tooltip>
        </el-upload>
        <el-upload style="display: inline-block"
                   ref="upload"
                   action=""
                   :auto-upload="false"
                   :on-change="query => onUploadFile(query, 256)"
                   accept=".xlsx,.xls"
                   :show-file-list="false">
          <el-tooltip content="上传表格的第一列请勿出现空值，出现空值将直接结束批量任务">
            <el-button icon="el-icon-delete"
                       type="danger"
                       size="small">批量移除用户
            </el-button>
          </el-tooltip>
        </el-upload>
      </div>
      <el-table :data="table"
                stripe
                highlight-current-row
                style="width: 100%">
        <el-table-column prop="userid"
                         label="用户id"
                         width="100px"></el-table-column>
        <el-table-column prop="cellphone"
                         label="手机号"
                         width="110px">
          <template slot-scope="scope">
            <router-link style="text-decoration:none"
                         :to="'/users/detail/info?userid='+scope.row.userid">
              <span style="color:rgb(88,157,248);">{{scope.row.cellphone}}</span>
            </router-link>
          </template>
        </el-table-column>
        <el-table-column prop="realname"
                         label="用户名称"
                         width="80px"></el-table-column>
        <el-table-column label="所在地"
                         width="150px">
          <template slot-scope="scope">
            <span>{{scope.row.provincename}}&nbsp;&nbsp;{{scope.row.cityname}}&nbsp;&nbsp;{{scope.row.areaname}}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="marketname"
                         label="所在卖场"></el-table-column>
        <el-table-column prop="registertime"
                         label="注册时间"></el-table-column>
        <el-table-column prop="status"
                         label="用户状态">
          <template slot-scope="scope">
            <span v-for="item in options.status"
                  v-if="item.value === parseInt(scope.row.status)">{{item.label}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="currentstatus"
                         label="用户当前状态">
          <template slot-scope="scope">
            <span v-for="item in options.currentstatus"
                  v-if="item.value === parseInt(scope.row.currentstatus)">{{item.label}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="idnumverified"
                         label="身份验证状态">
          <template slot-scope="scope">
            <span v-for="item in options.idnumverified"
                  v-if="item.value === parseInt(scope.row.idnumverified)">{{item.label}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="wx_account"
                         label="微信账号"></el-table-column>
        <el-table-column prop="memo"
                         label="备注"></el-table-column>
        <el-table-column prop="occupation_updated_at"
                         label="更新时间" />
        <el-table-column label="操作"
                         width="160px">
          <template slot-scope="scope">
            <el-button type="danger"
                       size="mini"
                       icon="el-icon-delete"
                       @click="remove(scope.row.userid)"
                       class="margin b5">移除
            </el-button>
          </template>
        </el-table-column>

      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
    <el-dialog title="添加用户"
               :visible.sync="addUserDialog.visible"
               width="30%">
      <el-form :model="addUserDialog"
               :rules="{userid: [{required: true, message: '用户不能为空', trigger: 'blur'}]}"
               label-width="96px"
               label-position="right"
               size="medium">
          <el-form-item label="选择用户"
                        prop="userid">
            <remote-select
              class="width-max"
              clearable
              id-key="userid"
              label-key="cellphone"
              value-key="userid"
              placeholder="请输入用户关键字"
              v-model="addUserDialog.userid"
              :query-request="getUserTable"
              :find-request="getUserDetail_" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addUserDialog.visible = false">取 消</el-button>
        <el-button type="primary" :disabled="!addUserDialog.userid" @click="onAddUser">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import table from '@core/mixins/table-v3'
import taskMixins from '@/views/task/task.mixins'

export default {
  mixins: [table, taskMixins],
  data () {
    return {
      addUserDialog: {
        visible: false,
        userid: null
      },
      userOptions: {
        tags: [],
      },
      loading: false,
      search: {
        id: null,
        keyword: null,
        occupation_id: this.$route.params.id
      },
      // 搜索字段申明
      searchFieldType: {
      },
      exportHeader: [
        {
          key: 'userid',
          text: '用户ID',
        },
        {
          key: 'realname',
          text: '真实姓名',
        },
        {
          key: 'provincename',
          text: '省份',
        },
        {
          key: 'cityname',
          text: '城市',
        },
        {
          key: 'areaname',
          text: '地区',
        },
        {
          key: 'id_card_province_name',
          text: '身份证省份',
        },
        {
          key: 'id_card_city_name',
          text: '身份证城市',
        },
        {
          key: 'id_card_area_name',
          text: '身份证地区',
        },
        {
          key: 'id_card_sex',
          text: '身份证性别',
        },
        {
          key: 'id_card_age',
          text: '身份证年龄',
        },
        {
          key: 'cellphone',
          text: '手机号码',
        },
        {
          key: 'strstatus',
          text: '用户状态',
        },
        {
          key: 'strcurrentstatus',
          text: '用户当前状态',
        },
        {
          key: 'referrer',
          text: '推荐人手机',
        },
        {
          key: 'registertime',
          text: '注册时间',
        },
        {
          key: 'cumulative_bounty',
          text: '累计赏金',
        },
        {
          key: 'balance',
          text: '账户余额',
        },
        {
          key: 'salary_last_update_time',
          text: '赏金最后更新时间',
        },
        {
          key: 'customername',
          text: '最后任务所属客户',
        },
        {
          key: 'tag_info',
          text: '主平台标签（显示名称）',
        },
        {
          key: 'clientmodel',
          text: '手机型号',
        },
        {
          key: 'devicenum',
          text: '手机设备号',
        },
        {
          key: 'clientversion',
          text: 'APP版本号',
        },
        {
          key: 'strlevel',
          text: '用户等级',
        },
        {
          key: 'str_is_super',
          text: '是否为超级零工',
        },
        {
          key: 'str_super',
          text: '超级零工属性',
        },
        {
          key: 'ability_group',
          text: '用户能力组',
        },
        {
          key: 'work_type',
          text: '工种',
        },
        {
          key: 'belongto',
          text: '厂家',
        },
        {
          key: 'referrer_belongto',
          text: '厂家关联',
        },
        {
          key: 'wx_account',
          text: '微信账号',
        },
        {
          key: 'occupation_text',
          text: '自选职业',
        },
      ],
    }
  },
  computed: Vuex.mapState({
    options: state => state.users.options,
    users: state => state.login.user,
    otherOptions: state => state.users.userOptions,
  }),
  created () {
    this.$store.dispatch('getUserRelatedOptions')
  },
  methods: {
    ...request.map([
      'getOccupationTable',
      'getOccupationDetail',
      'getUserTable',
      'getUserDetail_',
    ]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('getOccupationUserList', params)
    },
    onExportSearch () {
      let self = this
      this.$export(this.$route.meta.title, {
        fileHeader: this.exportHeader,
        total: this.pagination.total,
        request: (params) => request('exportUser', params),
        requestParams: this.search,
        getResponseData (data) {
          for (let m = 0; m < data.data.length; m++) {
            data.data[m].cumulative_bounty = parseFloat(data.data[m].balance) + parseFloat(data.data[m].frozenbalance) + parseFloat(data.data[m].totalwithdraw)
            console.log(data.data[m].customername)
            if (!data.data[m].customername) {
              data.data[m].customername = ''
            }

            if (data.data[m].id_card_age === false) {
              data.data[m].id_card_age = ''
            }

            if (data.data[m].id_card_sex === false) {
              data.data[m].id_card_sex = ''
            } else if (data.data[m].id_card_sex === 0) {
              data.data[m].id_card_sex = '男'
            } else if (data.data[m].id_card_sex === 1) {
              data.data[m].id_card_sex = '女'
            }

            for (let i = 0; i < self.options.status.length; i++) {
              if (parseInt(data.data[m].status) === self.options.status[i].value) {
                data.data[m].strstatus = self.options.status[i].label
              }
            }

            for (let i = 0; i < self.options.currentstatus.length; i++) {
              if (parseInt(data.data[m].currentstatus) === self.options.currentstatus[i].value) {
                data.data[m].strcurrentstatus = self.options.currentstatus[i].label
              }
            }

            for (let i = 0; i < self.options.level.length; i++) {
              if (parseInt(data.data[m].level) === self.options.level[i].value) {
                data.data[m].strlevel = self.options.level[i].label
              }
            }

            if (data.data[m].str_super_attr) {
              data.data[m].str_super = data.data[m].str_super_attr.join(',')
            }
            if (data.data[m].ability_group) {
              data.data[m].str_ability_group = data.data[m].ability_group.join(',')
            }
            data.data[m].str_is_super = data.data[m].is_super === 1 ? '是' : '不是'

            if (data.data[m].work_type && data.data[m].work_type !== '0') {
              for (let i = 0; i < self.otherOptions.work_type.length; i++) {
                if (parseInt(data.data[m].work_type) === self.otherOptions.work_type[i].id) {
                  data.data[m].work_type = self.otherOptions.work_type[i].keyword
                }
              }
            } else {
              data.data[m].work_type = ''
            }
          }
          return data
        },
      })
    },
    remove (userid) {
      this.$confirm('您确认要执行该操作吗？', '警告', {type: 'warning'}).then(() => {
        request.common('deleteOccupationUser', {id: this.search.occupation_id, userid}).then(() => {
          this.$message.success('操作成功！')
          this.onRefresh()
        })
      })
    },
    onAddUser () {
      request.common('addOccupationUser', {
        id: this.search.occupation_id,
        userid: this.addUserDialog.userid
      }).then(() => {
        this.addUserDialog.visible = false
        this.$message.success('操作成功！')
        this.onRefresh()
      })
    },
    onUploadFile (file, taskType) {
      let isLt10M = file.raw.size / 1024 / 1024 < 10

      if (!isLt10M) {
        this.$message.error('大小不能超过10MB!')
        this.$refs.upload.clearFiles()
        return false
      }

      let formData = new FormData()
      formData.append('file', file.raw)
      formData.append('collection_type', 1) // 集合类型为1
      formData.append('type', taskType)
      formData.append('params[occupation_id]', this.search.occupation_id)

      request.common('createTaskBatch', formData).then(({data}) => {
        this.$confirm('请问您是否想跳转至用户批量任务页面呢？', '温馨提示', {type: 'success'}).then(() => {
          this.$router.push('/users/batch/table')
        })
      })
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/views/occupation/pages/OccupationUsersTable.vue